import React from 'react'
import ReactDOM from 'react-dom'
// for styling
import { ThemeProvider } from '../src/utils/Functions/context'
import GlobalStyle from '../src/utils/style/GlobalStyle'
import App from './App'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
      <ThemeProvider>
        <GlobalStyle />
          <App />
      </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
